import script from "./HospitalDoctorProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalDoctorProfile.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalDoctorProfile.vue?vue&type=style&index=0&id=094018e4&lang=css"

const __exports__ = script;

export default __exports__